"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostBasketaddonsRequestToJSON = exports.PostBasketaddonsRequestFromJSONTyped = exports.PostBasketaddonsRequestFromJSON = exports.instanceOfPostBasketaddonsRequest = void 0;
var BasketItem_1 = require("./BasketItem");
/**
 * Check if a given object implements the PostBasketaddonsRequest interface.
 */
function instanceOfPostBasketaddonsRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "basketId" in value;
    isInstance = isInstance && "basketItems" in value;
    return isInstance;
}
exports.instanceOfPostBasketaddonsRequest = instanceOfPostBasketaddonsRequest;
function PostBasketaddonsRequestFromJSON(json) {
    return PostBasketaddonsRequestFromJSONTyped(json, false);
}
exports.PostBasketaddonsRequestFromJSON = PostBasketaddonsRequestFromJSON;
function PostBasketaddonsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'basketId': json['basketId'],
        'basketItems': (json['basketItems'].map(BasketItem_1.BasketItemFromJSON)),
    };
}
exports.PostBasketaddonsRequestFromJSONTyped = PostBasketaddonsRequestFromJSONTyped;
function PostBasketaddonsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'basketId': value.basketId,
        'basketItems': (value.basketItems.map(BasketItem_1.BasketItemToJSON)),
    };
}
exports.PostBasketaddonsRequestToJSON = PostBasketaddonsRequestToJSON;
